/*
 * @Author: LiuXueChao
 * @Date: 2023-03-03 11:25:17
 * @LastEditors: your name
 * @LastEditTime: 2023-03-03 13:59:53
 * @Description: file content
 */
module.exports = {
  title: '轻赢宝酒店管理系统',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
};
